






















































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyForm from "@/mixins/form";

import SelectOrders from "@/components/selectorders.vue";

@Component({
  components: {
    SelectOrders
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() itemId!: number;

  selectOrderModalVisible = false;

  refIds: string[] = [];

  showSelectOrderModal() {
    this.selectOrderModalVisible = true;
  }

  hideSelectOrderModal() {
    this.selectOrderModalVisible = false;
  }

  handleSelectOrder(e: any) {
    // console.log(e);

    this.refIds = e;

    this.hideSelectOrderModal();
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("stadium/settlementItemsDetailAdd", {
              stadium_id: this.stadiumId,
              item_id: this.itemId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
